import Layout from '@/components/Layout';
import SEOHead from '@/components/SEOHead';

export default function MentionsLegales() {
  return (
    <Layout>
      <SEOHead 
        title="Mentions Légales | Homely Conciergerie"
        description="Mentions légales de Homely Conciergerie - Informations légales, éditeur du site, hébergement et propriété intellectuelle."
        robots="noindex, follow"
      />
      <div className="min-h-screen bg-[#F5F3EF] py-12 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-[#2B2B2B] mb-8" data-testid="mentions-title">
            Mentions Légales
          </h1>

          <div className="bg-white rounded-2xl shadow-sm p-8 space-y-8">
            {/* Éditeur du site */}
            <section>
              <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-4">Éditeur du site</h2>
              <div className="text-[#4A4A4A] space-y-2">
                <p><strong>Raison sociale :</strong> Homely Solutions Sàrl</p>
                <p><strong>Marque commerciale :</strong> Homely Conciergerie (marque de Homely Solutions Sàrl)</p>
                <p><strong>Forme juridique :</strong> Société à responsabilité limitée (Sàrl)</p>
                <p><strong>Numéro IDE/UID :</strong> CHE-418.697.448</p>
                <p><strong>Numéro RC :</strong> Inscrite au Registre du Commerce du canton de Vaud</p>
                <p><strong>Capital social :</strong> CHF 20'000</p>
                <p><strong>Gérant :</strong> Mary-France Henry</p>
                <p><strong>Date de constitution :</strong> 4 octobre 2023</p>
                <p><strong>Adresse du siège social :</strong><br />
                  Rue Jean-André-Venel 4<br />
                  1400 Yverdon-les-Bains<br />
                  Suisse
                </p>
                <p><strong>Email :</strong> <a href="mailto:info@homely-solutions.com" className="text-[#8A9474] hover:underline">info@homely-solutions.com</a></p>
              </div>
            </section>

            {/* Hébergement */}
            <section>
              <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-4">Hébergement du site</h2>
              <div className="text-[#4A4A4A] space-y-2">
                <p><strong>Hébergeur web :</strong> Emergent Agent (infrastructure cloud)</p>
                <p>Ce site est hébergé sur des services cloud conformes aux standards de sécurité et de protection des données en vigueur en Suisse et dans l'Union Européenne.</p>
              </div>
            </section>

            {/* Directeur de publication */}
            <section>
              <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-4">Directeur de publication</h2>
              <div className="text-[#4A4A4A]">
                <p>Le directeur de publication du site est le gérant de Homely Solutions Sàrl.</p>
              </div>
            </section>

            {/* Propriété intellectuelle */}
            <section>
              <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-4">Propriété intellectuelle</h2>
              <div className="text-[#4A4A4A] space-y-3">
                <p>L'ensemble des contenus présents sur ce site (textes, images, photographies, logos, vidéos, icônes, sons, logiciels, bases de données, etc.) est la propriété exclusive de Homely Solutions Sàrl ou fait l'objet d'une autorisation d'utilisation.</p>
                <p>Toute reproduction, représentation, modification, publication, adaptation, totale ou partielle, des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de Homely Solutions Sàrl.</p>
                <p>Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions du Code pénal suisse et du droit de la propriété intellectuelle.</p>
              </div>
            </section>

            {/* Protection des données personnelles */}
            <section>
              <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-4">Protection des données personnelles</h2>
              <div className="text-[#4A4A4A] space-y-3">
                <p>Conformément à la nouvelle loi fédérale sur la protection des données (nLPD) et au Règlement général sur la protection des données (RGPD) lorsqu'applicable, Homely Solutions Sàrl s'engage à protéger la confidentialité des données personnelles collectées via ce site.</p>
                <p><strong>Responsable du traitement des données :</strong><br />
                  Homely Solutions Sàrl<br />
                  Jean-André Venel 4<br />
                  1400 Yverdon-les-Bains<br />
                  Email : <a href="mailto:info@homely-solutions.com" className="text-[#8A9474] hover:underline">info@homely-solutions.com</a>
                </p>
                <p><strong>Données collectées :</strong><br />
                  Dans le cadre de la demande d'estimation ou de prise de contact, nous collectons les données suivantes : nom, prénom, adresse email, numéro de téléphone, informations relatives au bien immobilier (type, localisation, nombre de chambres, capacité d'accueil, adresse).
                </p>
                <p><strong>Finalités du traitement :</strong><br />
                  Les données personnelles sont collectées afin de traiter votre demande d'estimation, de vous recontacter dans le cadre de nos services de gestion locative, et de gérer la relation commerciale.
                </p>
                <p><strong>Durée de conservation :</strong><br />
                  Les données sont conservées pendant la durée nécessaire à la gestion de votre demande et à l'exécution des services, puis archivées conformément aux obligations légales en vigueur.
                </p>
                <p><strong>Droits des personnes concernées :</strong><br />
                  Conformément à la nLPD et au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation du traitement, d'opposition et de portabilité de vos données personnelles. Vous pouvez exercer ces droits en nous contactant à l'adresse : <a href="mailto:info@homely-solutions.com" className="text-[#8A9474] hover:underline">info@homely-solutions.com</a>.
                </p>
                <p>Vous disposez également du droit d'introduire une réclamation auprès de l'autorité de surveillance compétente (Préposé fédéral à la protection des données et à la transparence – PFPDT – en Suisse).</p>
              </div>
            </section>

            {/* Cookies */}
            <section>
              <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-4">Cookies</h2>
              <div className="text-[#4A4A4A] space-y-3">
                <p>Ce site peut utiliser des cookies afin d'améliorer l'expérience utilisateur et de réaliser des statistiques de visite. Un cookie est un petit fichier texte stocké sur votre terminal lors de la consultation d'un site internet.</p>
                <p>Vous pouvez à tout moment désactiver les cookies depuis les paramètres de votre navigateur. Toutefois, cela peut limiter certaines fonctionnalités du site.</p>
              </div>
            </section>

            {/* Liens hypertextes */}
            <section>
              <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-4">Liens hypertextes</h2>
              <div className="text-[#4A4A4A] space-y-3">
                <p>Le site peut contenir des liens hypertextes vers d'autres sites internet. Homely Solutions Sàrl ne saurait être tenue responsable du contenu de ces sites tiers ni des éventuels dommages résultant de leur consultation.</p>
              </div>
            </section>

            {/* Responsabilité */}
            <section>
              <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-4">Limitation de responsabilité</h2>
              <div className="text-[#4A4A4A] space-y-3">
                <p>Homely Solutions Sàrl met tout en œuvre pour offrir aux visiteurs du site des informations exactes et régulièrement mises à jour. Toutefois, des erreurs ou omissions peuvent survenir. Le visiteur devra donc s'assurer de l'exactitude des informations et signaler toute erreur constatée.</p>
                <p>Homely Solutions Sàrl ne pourra être tenue responsable des dommages directs ou indirects résultant de l'accès au site ou de l'utilisation du site, y compris l'inaccessibilité, les pertes de données, détériorations, destructions ou virus qui pourraient affecter l'équipement informatique de l'utilisateur.</p>
              </div>
            </section>

            {/* Droit applicable */}
            <section>
              <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-4">Droit applicable et juridiction compétente</h2>
              <div className="text-[#4A4A4A] space-y-3">
                <p>Les présentes mentions légales sont soumises au droit suisse.</p>
                <p>En cas de litige relatif à l'interprétation, l'exécution ou la validité des présentes mentions légales, et à défaut de règlement amiable, les tribunaux du siège de Homely Solutions Sàrl (Yverdon-les-Bains, canton de Vaud, Suisse) seront seuls compétents.</p>
              </div>
            </section>

            {/* Date de mise à jour */}
            <section>
              <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-4">Infrastructure digitale et acquisition client</h2>
              <div className="text-[#4A4A4A]">
                <p>
                  Infrastructure digitale et acquisition client : <a href="https://darven.ch" target="_blank" rel="noopener noreferrer" className="text-[#8A9474] hover:underline font-medium">Darven</a>
                </p>
                <p className="mt-2 text-sm">
                  Darven fournit l'infrastructure digitale et les outils d'acquisition client permettant à Homely Conciergerie d'optimiser sa présence en ligne et sa génération de leads.
                </p>
              </div>
            </section>

            {/* Date de dernière mise à jour */}
            <section>
              <h2 className="text-2xl font-semibold text-[#2B2B2B] mb-4">Date de dernière mise à jour</h2>
              <div className="text-[#4A4A4A]">
                <p>Les présentes mentions légales ont été mises à jour le 4 octobre 2026.</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}
